document.addEventListener('DOMContentLoaded', function() {
    //checkAndRedirectToIT();

    var currentCountry = getParameterByName('country') || 'IT';
    var currentLang = getParameterByName('lang') || 'IT'; // Menambahkan pemeriksaan bahasa, default IT

    updateShipToButton(currentCountry, currentLang);

    document.getElementById("choose-country-shipButton").addEventListener("click", function () {
        document.getElementById("choose-country-countryPopup").style.display = "flex";
    });

    document.getElementById("choose-country-closePopup").addEventListener("click", function () {
        document.getElementById("choose-country-countryPopup").style.display = "none";
    });

    window.onclick = function (event) {
        var popup = document.getElementById("choose-country-countryPopup");
        if (event.target == popup) {
            popup.style.display = "none";
        }
    };

    appendCountryParamToLinks();

    document.querySelectorAll('.country-selector').forEach(function(el) {
        el.addEventListener('click', function(e) {
            e.preventDefault();
            var selectedCountry = this.getAttribute('data-country');
            updateShipToButton(selectedCountry, currentLang);

            var baseURL = window.location.href.split('?')[0];
            window.location.href = baseURL + '?country=' + selectedCountry + '&lang=' + currentLang;
        });
    });

    var currentURL = window.location.href;
    var languageToggleButton = document.getElementById('language-toggle-button');
    var popupTitle = document.querySelector('#language-popup h2');
    var popupDescription = document.querySelector('#language-popup p');
    var italianOption = document.getElementById('select-italian');
    var englishOption = document.getElementById('select-english');

    if (currentURL.includes('/en') || currentURL.includes('/en/')) {
        languageToggleButton.textContent = 'LANGUAGE: EN';
        popupTitle.textContent = 'PLEASE SELECT YOUR LANGUAGE';
        popupDescription.textContent = 'Changing the language does not modify the selected Country or currency. Choose your preferred language from the options below.';
        italianOption.textContent = 'Italian';
        englishOption.textContent = 'English';
    } else {
        languageToggleButton.textContent = 'LINGUA: IT';
        popupTitle.textContent = 'SELEZIONA LA LINGUA';
        popupDescription.textContent = 'Cambiare lingua di navigazione non modifica il Paese o la valuta selezionati. Scegli la lingua che preferisci tra le opzioni disponibili.';
        italianOption.textContent = 'Italiano';
        englishOption.textContent = 'Inglese';
    }

    document.getElementById('language-toggle-button').addEventListener('click', function () {
        document.getElementById('language-popup').style.display = 'flex';
    });

    document.getElementById('close-language-popup').addEventListener('click', function () {
        document.getElementById('language-popup').style.display = 'none';
    });

    window.onclick = function (event) {
        var popup = document.getElementById('language-popup');
        if (event.target == popup) {
            popup.style.display = 'none';
        }
    };

    document.getElementById('select-italian').addEventListener('click', function () {
        changeLanguage('IT');
    });

    document.getElementById('select-english').addEventListener('click', function () {
        changeLanguage('EN');
    });

    var elements = document.getElementsByClassName('choose-country-accordion');
    for (let i = 0; i < elements.length ; i++) {
      elements[i].addEventListener('click', function() {
        this.nextElementSibling.classList.toggle('active')
      })
    }
});

function updateShipToButton(countryCode, lang) {
    console.log("Updating content for country:", countryCode);
    var shipButton = document.getElementById('choose-country-shipButton');
    var countryTitle = document.getElementById('choose-country-title');
    var countryDescription = document.getElementById('choose-country-description');

    if (!shipButton || !countryTitle || !countryDescription) {
        console.error("Ship button or translation elements not found!");
        return;
    }

    var countryName = '';

    switch (countryCode) {
        case 'SA':
            countryName = 'Saudi Arabia';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Saudi Arabia';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Arabia Saudita';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'AR':
            countryName = 'Argentina';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Argentina';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Argentina';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'AU':
            countryName = 'Australia';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Australia';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Australia';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'AT':
            countryName = 'Austria';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Austria';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Austria';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'BE':
            countryName = 'Belgium';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Belgium';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Belgio';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'BR':
            countryName = 'Brazil';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Brazil';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Brasile';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'BG':
            countryName = 'Bulgaria';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Bulgaria';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Bulgaria';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'CA':
            countryName = 'Canada';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Canada';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Canada';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'CZ':
            countryName = 'Czechia';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Czechia';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Cechia';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'CL':
            countryName = 'Chile';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Chile';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Cile';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'CN':
            countryName = 'China';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : China';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Cina';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'CY':
            countryName = 'Cyprus';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Cyprus';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Cipro';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'KR':
            countryName = 'South Korea';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : South Korea';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Corea del Sud';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'HR':
            countryName = 'Croatia';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Croatia';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Croazia';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'DK':
            countryName = 'Denmark';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Denmark';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Danimarca';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'AE':
            countryName = 'United Arab Emirates';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : United Arab Emirates';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Emirati Arabi Uniti';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'EE':
            countryName = 'Estonia';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Estonia';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Estonia';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'FI':
            countryName = 'Finland';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Finland';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Finlandia';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'FR':
            countryName = 'France';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : France';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Francia';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'DE':
            countryName = 'Germany';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Germany';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Germania';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'JP':
            countryName = 'Japan';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Japan';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Giappone';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'GR':
            countryName = 'Greece';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Greece';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Grecia';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'IN':
            countryName = 'India';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : India';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: India';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'ID':
            countryName = 'Indonesia';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Indonesia';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Indonesia';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'IQ':
            countryName = 'Iraq';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Iraq';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Iraq';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'IE':
            countryName = 'Ireland';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Ireland';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Irlanda';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'IL':
            countryName = 'Israel';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Israel';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Israele';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'IT':
            countryName = 'Italy';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Italy';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Italia';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'LT':
            countryName = 'Lithuania';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Lithuania';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Lituania';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'LU':
            countryName = 'Luxembourg';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Luxembourg';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Lussemburgo';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'MY':
            countryName = 'Malaysia';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Malaysia';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Malaysia';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'MT':
            countryName = 'Malta';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Malta';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Malta';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'MX':
            countryName = 'Mexico';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Mexico';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Messico';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'NO':
            countryName = 'Norway';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Norway';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Norvegia';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'NZ':
            countryName = 'New Zealand';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : New Zealand';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Nuova Zelanda';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'NL':
            countryName = 'Netherlands';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Netherlands';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Paesi Bassi';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'PL':
            countryName = 'Poland';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Poland';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Polonia';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'PT':
            countryName = 'Portugal';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Portugal';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Portogallo';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'HK':
            countryName = 'Hong Kong SAR';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Hong Kong SAR';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: RAS di Hong Kong';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'GB':
            countryName = 'United Kingdom';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : United Kingdom';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Regno Unito';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'RO':
            countryName = 'Romania';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Romania';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Romania';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'SG':
            countryName = 'Singapore';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Singapore';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Singapore';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'SK':
            countryName = 'Slovakia';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Slovakia';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Slovacchia';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'ES':
            countryName = 'Spain';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Spain';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Spagna';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'US':
            countryName = 'United States';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : United States';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Stati Uniti';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'SE':
            countryName = 'Sweden';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Sweden';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Svezia';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'CH':
            countryName = 'Switzerland';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Switzerland';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Svizzera';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'TR':
            countryName = 'Turkey';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Turkey';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Turchia';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'UA':
            countryName = 'Ukraine';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Ukraine';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Ucraina';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        case 'HU':
            countryName = 'Hungary';
            if (lang === 'EN') {
                shipButton.textContent = 'COUNTRY : Hungary';
                countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
                countryDescription.innerHTML =
                    'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
            } else {
                shipButton.textContent = 'PAESE: Ungheria';
                countryTitle.innerHTML = 'SELEZIONA PAESE';
                countryDescription.innerHTML =
                    'Seleziona il Paese dove vuoi effettuare la spedizione. Cambiare Paese di spedizione potrebbe rimuovere i prodotti dal tuo Carrello.';
            }
            break;
        default:
            countryName = 'Unknown Country';
            shipButton.textContent = 'Country ' + countryName;
            countryTitle.innerHTML = 'PLEASE SELECT YOUR COUNTRY';
            countryDescription.innerHTML =
                'Please select the right country where you want to ship. Be aware that changing your location while shopping will remove all items from your Cart.';
    }
}

function changeLanguage(lang) {
    var currentCountry = getParameterByName('country') || 'IT';
    var currentURL = window.location.href;
    
    var baseURL = currentURL.split('?')[0];

    if (lang === 'IT') {
        if (baseURL.includes('/en')) {
            baseURL = baseURL.replace('/en', '');
        }
        window.location.href = baseURL + '?country=' + currentCountry + '&lang=IT';
    } else if (lang === 'EN') {
        if (!baseURL.includes('/en')) {
            baseURL = baseURL.replace('https://shop.comofootball.com', 'https://shop.comofootball.com/en');
        }
        window.location.href = baseURL + '?country=' + currentCountry + '&lang=EN';
    }
}



function getParameterByName(name) {
    let url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    let results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function checkAndRedirectToIT() {
    if (!getParameterByName('country')) {
        window.location.href = window.location.pathname + '?country=IT&lang=IT'; 
    }
}

function appendCountryParamToLinks() {
    var currentCountry = getParameterByName('country') || 'IT';
    if (currentCountry) {
        document.querySelectorAll('a').forEach(function(link) {
            let href = link.getAttribute('href');
            if (href && href.indexOf('javascript:') === -1 && href.indexOf('#') === -1) {
                if (href.indexOf('?') > -1) {
                    link.setAttribute('href', href + '&country=' + currentCountry);
                } else {
                    link.setAttribute('href', href + '?country=' + currentCountry);
                }
            }
        });
    }
}
